import type { CustomerOverview } from '@vy/api-definition';
import { LABEL_ENTITY_TYPES } from '@vy/types';
import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import { useQueryClient } from 'react-query';
import { EntityLabelsCell } from '../../../../components/new-design/molecules/labels';
import { queryKeys } from '../../../../services/query-key/query-keys';

type CustomerLabelsCellProps = {
  customer: CustomerOverview;
};

export const CustomerLabelsCell: FC<CustomerLabelsCellProps> = ({ customer }) => {
  const queryClient = useQueryClient();

  const labelIds = useMemo(() => {
    return (customer.labels ?? []).map((label) => label.id);
  }, [customer.labels]);

  const handleUpdateSuccess = useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries(queryKeys.customersOverviewsNew()),
      queryClient.invalidateQueries([queryKeys.labels()]),
    ]);
  }, [queryClient]);

  return (
    <EntityLabelsCell
      entityType={LABEL_ENTITY_TYPES.CUSTOMER}
      entityId={customer.id}
      labelIds={labelIds}
      onUpdateSuccess={handleUpdateSuccess}
    />
  );
};
